let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aH3js")).then(() => parcelRequire('2UazD'));